
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-map-marker', VueGoogleMaps.Marker);


Vue.component('search-details', {
  props: {
    skrot2: {},
    room: { default: '' },
    alimentation: { default: '' }
  },
  template: '#vue-search-details',
  data: function () {
    return {
      scroll: 1,
      agent: '',
      touroperator: '',
      getPriceUrl: '',
      showPrice: false,
      HotelResStatus: '',
      error: locales('components.search-details.js.count'),
      price: '',
      currency: '',
      struckPrice: '',
      discountValue: '',
      discountPercentage: '',
      discountType: '',
      discountName: '',
      departurePlace: '',
      arrivalPlace: '',
      params: {
        mw: '',
        room: '',
        alimentation: '',
        start_date: '',
        end_date: '',
        adults: 2,
        childrens: 0,
        age_child_1: '',
        age_child_2: '',
        age_child_3: '',
        age_child_4: '',
      },
      config: {
        mw: [],
        room: [],
        alimentation: [],
        combinations: [],
        adults: [],
        childrens: [],
        age_child_1: [],
        age_child_2: [],
        age_child_3: [],
        age_child_4: [],
        soldout_days_from: [],
        soldout_days_to: [],
        show: {
          age_child_1: false,
          age_child_2: false,
          age_child_3: false,
          age_child_4: false,
          mw: false
        },
        is_bed_bank: false
      },
      diagram: {
        content: "",
        first: {},
        second: {}
      },
      detailsElement: null,
      flagWatchParams: false,
      notExist: false,
      vSliderItemClass: 'vSliderItemClass',
      imgSelected: {
        'Miasto': null,
        'Kraj': null,
        'Obiekt': null
      },
      showTab: {
        gallery: false,
        gmap: false,
        documents: false,
        attractions: false
      },
      breadcrumbNow: {
        text: locales('components.breadcrumbs.search-details'),
        textDef: locales('components.breadcrumbs.search-details')
      }
    }
  },
  computed: {
    locationHref: function () { return utoa(window.location.href); }
  },
  created: function () {
    const self = this;

    if (firstLoad === false) {
      firstLoad = true;
    }

    serverBus.$emit('loading_start');

    self.getDetails(self.skrot2, self.room, self.alimentation);

    self.params.mw = self.mw;
    self.params.room = self.room;
    self.params.alimentation = self.alimentation;
    self.setParamsFromGet();

    if (self.scroll) document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  updated: function () {
    //	  document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  watch: {
    skrot2: function (newSkrot, oldSkrot) {
      this.detailsElement = this.getDetails(newSkrot);
      //            document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    'params.childrens': function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.showSelectAgeChildrens(newValue);
      }
    },
    'params.start_date': function (newValue, oldValue) {
      const self = this;
      if (moment(newValue, 'DD.MM.YYYY', true).isValid()) {
        $("input#start_date").datepicker("update", newValue);
        if (self.agent == "lulubeds2www") {
          self.params.end_date = moment(newValue, "DD.MM.YYYY").add(1, 'days').format('DD.MM.YYYY');
        } else if (self.datesCompare(newValue, self.params.end_date)) {
          self.params.end_date = newValue;
        }
      }
    },
    'params.end_date': function (newValue, oldValue) {
      const self = this;
      if (moment(newValue, 'DD.MM.YYYY', true).isValid()) {
        $("input#end_date").datepicker("update", newValue);
        if (self.datesCompare(self.params.start_date, newValue)) self.params.start_date = newValue;
      }
    },
    'params': {
      handler: function (newValue, oldValue) {
        if (this.flagWatchParams) {
          this.reloadPageWithNewPath();
          //                    document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
      },
      deep: true
    }
  },
  methods: {
    prepareNewGallery: function (newKey) {
      const self = this;
      if (!(newKey in self.imgSelected)) {
        self.imgSelected[newKey] = null;
      }
    },
    showTab_f: function (nazwa) {
      const self = this;
      if (!self.showTab[nazwa]) self.showTab[nazwa] = true;
    },
    showSelectAgeChildrens: function (how_much) {
      const self = this;

      for (let i = 1; i <= 4; i++) {
        if (how_much >= i) {
          self.config.show['age_child_' + i] = true;

        } else {
          self.config.show['age_child_' + i] = false;
          self.params['age_child_' + i] = '';

        }
      }
    },
    datesCompare: function (date1, date2) {
      const res1 = date1.split(".");
      const res2 = date2.split(".");
      return (res1[2] + res1[1] + res1[0] > res2[2] + res2[1] + res2[0]);
    },
    createDatePicker: function (i_max, i) {
      const self = this;

      if ($('body #start_date')[0] && $('body #end_date')[0]) {
        setTimeout(function () {
          $('.input-daterange #start_date').datepicker({
            format: "dd.mm.yyyy",
            language: lang,
            autoclose: true,
            startDate: "dateToday",
            datesDisabled: self.config.soldout_days_from
          }).on('changeDate', function (e) {
            self.params[e.target.id] = e.target.value;
          });
        }, 300);

        setTimeout(function () {
          $('.input-daterange #end_date').datepicker({
            format: "dd.mm.yyyy",
            language: lang,
            autoclose: true,
            startDate: "dateToday",
            datesDisabled: self.config.soldout_days_to
          }).on('changeDate', function (e) {
            self.params[e.target.id] = e.target.value;
          });
        }, 300);

      } else if (i < i_max) {
        let timeForTimeout = 200 + (Math.pow(i, 3) * 8);
        //				console.log('createDatePicker [NOK]: ' + i + ' | max: ' + i_max + ' | timeForTimeout: ' + timeForTimeout);
        //				console.log(self.params);
        setTimeout(function () {
          ++i;
          self.createDatePicker(i_max, i);
        }, timeForTimeout);
      }
    },
    setAdultsAndChildrens: function () {
      const self = this;

      if (self.config.combinations !== undefined) {
        Object.keys(self.config.combinations).forEach(function (adults) {
          self.config.adults.push({ "text": adults, "value": adults });
        });

        if (self.config.combinations[self.params.adults] !== undefined && self.config.combinations[self.params.adults] !== null && Object.keys(self.config.combinations[self.params.adults])) {
          Object.keys(self.config.combinations[self.params.adults]).forEach(function (key) {
            let children = self.config.combinations[self.params.adults][key];
            self.config.childrens.push({ "text": children, "value": children });
          });
        }
      }
    },
    getDetails: function (skrot2, room, alimentation) {
      const self = this;

      if (typeof respSearchDetails !== 'undefined' && respSearchDetails) {
        // console.log('[cURL] /back/search/SearchDetails.php');

        const result = respSearchDetails;
        respSearchDetails = '';

        self.getDetailsCallback(result, skrot2, room, alimentation);

      } else {
        // console.log('[Fetch/XHR] /back/search/SearchDetails.php');

        $.post(
          "/back/search/SearchDetails.php", 
          { 
						skrot2: skrot2, 
						room: room, 
						alimentation: alimentation, 
						adults: this.$route.query['adults'], 
						children: this.$route.query['childrens'], 
						start_date: this.$route.query['start_date'], 
						end_date: this.$route.query['end_date'] 
					}, 
          function (result, textStatus) {
            self.getDetailsCallback(result, skrot2, room, alimentation);
          },
          "json"
        ).fail(function () {
          self.notExist = true;
          setMetaNoIndex();
        });
      }
    },
    getDetailsCallback: function (result, skrot2, room, alimentation) {
      const self = this;

      if (typeof result.config.show !== 'undefined' && typeof result.config.show.mw !== 'undefined') self.config.show.mw = result.config.show.mw;

      if (alimentation != result["details"]["alimentation"] && result["details"]["alimentation"]) {
        if (result["config"]["agent"] == "lulubeds2www" || (typeof config['details-ceo'] !== "undefined" && config['details-ceo'])) {
          router.replace({ name: 'details-ceo', params: { skrot2: skrot2, room: room, alimentation: result["details"]["alimentation"], f_city: result["details"]["city"], f_region: result["details"]["region"], f_name: result["details"]["title"] }, query: self.$route.query });
        } else {
          router.replace({ name: 'details', params: { skrot2: skrot2, room: room, alimentation: result["details"]["alimentation"] }, query: self.$route.query });
        }
      }
      self.changeTitleAndDescription(result["details"]);
      setMeta("keywords", mainMetaKeywordsStatic + ", " + result["details"]["keywords_page"]);

      let pathParts = '', nameForPath = '', locationPathname = '';
      
      if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(result["config"]["agent"])) {
        pathParts = location.pathname.split("/");
        nameForPath = (result.details.type == 'Atrakcja') ? result["details"]["nice_room_name"] : result["details"]["title"];
        locationPathname = '/' + [pathParts[1], pathParts[2], result["details"]["region"], result["details"]["city"], nameForPath, skrot2].join('/');
      } else {
        locationPathname = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
        locationPathname = locationPathname.substring(0, locationPathname.lastIndexOf("/"));
      }

      let setCanonicalTagUrl = 'https://' + location.host + locationPathname + '/';

      if (typeof result["config"]["room"] !== 'undefined' && result["config"]["room"] !== null && typeof result["config"]["room"][0] !== 'undefined' && typeof result["config"]["room"][0]['value'] !== 'undefined') {
        setCanonicalTagUrl += encodeURI(result["config"]["room"][0]['value']) + '/';
      } else {
        setCanonicalTagUrl += encodeURI(room) + '/';
      }

      if (typeof result["config"]["alimentation"] !== 'undefined' && result["config"]["alimentation"] !== null && typeof result["config"]["alimentation"][0] !== 'undefined' && typeof result["config"]["alimentation"][0]['value'] !== 'undefined') {
        setCanonicalTagUrl += encodeURI(result["config"]["alimentation"][0]['value']);
      } else {
        setCanonicalTagUrl += 'AA';
      }

      setCanonicalTag(setCanonicalTagUrl);

      self.agent = result["config"]["agent"];
      self.setGetPriceUrl(self.agent);
      self.touroperator = result["config"]["touroperator"];

      self.config.mw = result["config"]["mw"];
      self.config.room = result["config"]["room"];

      let roomTMP = result.details.room.replaceAll("/", "|");
      if (roomTMP && self.params.room != roomTMP) {
        self.params.room = roomTMP;
      }

      let alimentationTMP = result.details.alimentation.replaceAll("/", "|");
      if (alimentationTMP && self.params.alimentation != alimentationTMP) {
        self.params.alimentation = alimentationTMP;
      }

      self.config.alimentation = result["config"]["alimentation"];

      self.config.combinations = result["config"]["combinations"];
      self.setAdultsAndChildrens();

      self.config.age_child_1 = result["config"]["age_child_1"];
      self.config.age_child_2 = result["config"]["age_child_2"];
      self.config.age_child_3 = result["config"]["age_child_3"];
      self.config.age_child_4 = result["config"]["age_child_4"];

      self.setFirstIfNone('adults');
      self.setFirstIfNone('childrens');
      self.setFirstIfNone('age_child_1');
      self.setFirstIfNone('age_child_2');
      self.setFirstIfNone('age_child_3');
      self.setFirstIfNone('age_child_4');

      if (result["config"]["soldout_days_from"] !== null) self.config.soldout_days_from = Object.values(result["config"]["soldout_days_from"]);
      if (result["config"]["soldout_days_from"] !== null) self.config.soldout_days_to = Object.values(result["config"]["soldout_days_to"]);
      if (result["config"]["soldout_days_from"] !== null) self.config.is_bed_bank = result["config"]["is_bed_bank"];

      self.detailsElement = result["details"];
      if (self.detailsElement.places !== undefined) {
        self.detailsElement.places.forEach(function (place, key) {
          self.detailsElement.places[key].y = parseFloat(place.y);
          self.detailsElement.places[key].x = parseFloat(place.x);
        });
      }

      if (self.detailsElement.images !== undefined && self.detailsElement.images !== null && Object.keys(self.detailsElement.images)) {
        if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agent)) self.prepareNewGallery('Obiekt');
        Object.keys(self.detailsElement.images).forEach(function (key) {
          let srcset = {};
          if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agent) && typeof self.detailsElement.images[key].url !== 'undefined') {
            self.detailsElement.images[key].href = self.detailsElement.images[key].url;
          }
          if (typeof self.detailsElement.images[key] !== 'undefined' && self.detailsElement.images[key] !== null) {
            if (typeof self.detailsElement.images[key].url2 !== 'undefined' && self.detailsElement.images[key].url2 !== null && self.detailsElement.images[key].url2 !== '') {
              // srcset.s = self.detailsElement.images[key].url2.replace(/\.([^\.]*)$/,'s.$1');
              if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agent)) srcset.m = self.detailsElement.images[key].url2.replace(/\.([^\.]*)$/, 'm.$1');
              srcset.l = self.detailsElement.images[key].url2.replace(/\.([^\.]*)$/, 'l.$1');
            } else if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agent)) {
              srcset.m = self.detailsElement.images[key].href;
              srcset.l = self.detailsElement.images[key].href;
            }
          } else {
            srcset.m = srcset.l = ''
          }
          self.detailsElement.images[key].srcset = srcset;
        });
      }

      if (self.detailsElement.gallery !== undefined && self.detailsElement.gallery !== null && Object.keys(self.detailsElement.gallery)) {
        Object.keys(self.detailsElement.gallery).forEach(function (key) {
          self.prepareNewGallery(key);
          self.detailsElement.gallery[key].forEach(function (image, key2) {
            let srcset = {};
            if (typeof image.href !== 'undefined' && image.href !== null && image.href !== '') {
              // srcset.s = image.href.replace(/\.([^\.]*)$/,'s.$1');
              srcset.m = image.href.replace(/\.([^\.]*)$/, 'm.$1');
              srcset.l = image.href.replace(/\.([^\.]*)$/, 'l.$1');
            }
            self.detailsElement.gallery[key][key2].srcset = srcset;
          });
        });
      }

      self.breadcrumbNow.text = self.breadcrumbNow.textDef + ' - ';
      if (self.detailsElement.nice_hotel_name) {
        self.breadcrumbNow.text += self.detailsElement.nice_hotel_name + ' (';
        if (self.detailsElement.nice_room_name) self.breadcrumbNow.text += self.detailsElement.nice_room_name;
        else self.breadcrumbNow.text += self.detailsElement.room;
        self.breadcrumbNow.text += ')';
      } else self.breadcrumbNow.text += self.detailsElement.title;

      if (self.detailsElement) self.notExist = false;
      else self.notExist = true;

      self.getPrice();
      setTimeout(function () {
        serverBus.$emit('loading_end');
      }, 500);
      self.flagWatchParams = true;

      self.createDatePicker(10, 0);
    },
    changeTitleAndDescription: function (offer) {
      const self = this;
      // self.params.type -> paramsType // TO DO: Pobieranie tekstow dla self.params.type
      // console.log(' ----------- self.params.type');
      // console.log(self.params.type);
      let paramsType = '';
      // if (self.params.destination && self.params.destination != 'default') {
      //     if (self.params.type == "AP") paramsType = "Apartament";
      //     else if (self.params.type == "TX") paramsType = "Bilety na imprezy";
      //     else if (self.params.type == "H") paramsType = "Hotel";
      //     else paramsType = self.params.type;
      //     paramsType += ' w ';
      // }

      // title
      let documentTitle = '', offerName = '';
      if (agentx == "kompas2www" || agentx == "kompasoasis2www") {
        offerName = (typeof offer["title"] !== 'undefined') ? offer["title"] : offer["nice_hotel_name"]; // a nie na odwrot?
        documentTitle = offerName;
      } else if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(agentx)) {
        offerName = (typeof offer["nice_hotel_name"] !== 'undefined') ? offer["nice_hotel_name"] : offer["title"];
        documentTitle = offerName;
        if (typeof offer["city"] !== 'undefined' && offer["city"]) documentTitle += ', ' + offer["city"];
      } else {
        offerName = (typeof offer["nice_hotel_name"] !== 'undefined') ? offer["nice_hotel_name"] : offer["title"];
        if (typeof offer["nice_room_name"] !== 'undefined' && offer["nice_room_name"]) offerName += ' - ' + offer["nice_room_name"];
        documentTitle = offerName;
        if (typeof offer["type"] !== 'undefined' && offer["type"]) documentTitle = offer["type"] + " " + documentTitle;
        if (typeof offer["city"] !== 'undefined' && offer["city"]) documentTitle += ', ' + offer["city"];
        if (typeof offer["region"] !== 'undefined' && offer["region"]) documentTitle += ', ' + offer["region"];
        if (typeof offer["country"] !== 'undefined' && offer["country"]) documentTitle += ', ' + offer["country"];
      }
      setPageTitle(documentTitle + mainMetaTitleStatic);

      // meta description
      let newDescription = '';
      newDescription += mainMetaDescriptionOfferBefore + paramsType + offerName;
      newDescription += " (" + offer.country + ", " + offer.region + ", " + offer.city + ")";
      newDescription += mainMetaDescriptionOfferAfter;
      if (offer["description_page"]) {
        newDescription += " " + offer["description_page"].replace(/\s\s+/g, ' ');
      }
      setMeta("description", newDescription);
    },
    setFirstIfNone: function (name) {
      const self = this;
      if (typeof self.config[name] !== 'undefined' && typeof self.params[name] !== 'undefined') {
        let none = true;
        for (let i = 0, len = self.config[name].length; i < len; i++) {
          if (self.config[name][i].value == self.params[name]) {
            none = false;
            break;
          }
        }
        if (none && self.config[name][0] !== undefined) {
          self.params[name] = self.config[name][0].value;
        }
      }
    },
    getPopUpLink: function () {
      const self = this;
      let roomtype = encodeURIComponent((self.room == '-') ? '' : self.room.replaceAll("|", "/"));
      let skrot2 = encodeURIComponent(self.skrot2);
      let skrot = self.skrot2;
      if (self.room && self.room != "-") skrot += ' ' + self.room.replaceAll("|", "/");
      if (self.agent == "kompas2www" || self.agent == "kompasoasis2www") { //
        skrot += " " + self.alimentation.replaceAll("AA", "");
      } else if (self.alimentation && self.alimentation != "AA") skrot += ' ' + self.alimentation;
      skrot = encodeURIComponent(skrot);

      let href = "";
      if (self.agent == "kompas2www" || self.agent == "kompasoasis2www") {
        href = "//wwwgen.sykon.pl/afiliacjaariadna/agx/" + self.agent + "/index.php?onepage=20&adults=" + self.params.adults + "&child1=" + self.params.age_child_1 + "&child2=" + self.params.age_child_2 + "&child3=" + self.params.age_child_3 + "&child4=" + self.params.age_child_4 + "&md=" + skrot + "|" + self.params.start_date + "|" + self.params.end_date + "&r_opt=1";
        //
      } else if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agent)) {
        let langLong = '';
        switch (lang) {
          case 'pl':
            langLong = 'Polska';
            break;
          case 'en':
            langLong = 'Wielka Brytania';
            break;
          case 'de':
            langLong = 'Niemcy';
            break;
        }
        href = "//wwwgen.sykon.pl/afiliacjaariadna1B/agx/" + self.agent + "/index.php?szukaj=szukaj_wycieczki&adults=" + self.params.adults + "&child1=" + self.params.age_child_1 + "&child2=" + self.params.age_child_2 + "&child3=" + self.params.age_child_3 + "&child4=" + self.params.age_child_4 + "&top=" + self.touroperator + "&rewrite=on&tourop=agx&agentx=" + self.agent + "&onepage=20&from=" + self.params.start_date + "&to=" + self.params.end_date + "&tourop_hotel=" + self.touroperator + "|" + self.detailsElement.skrot + "&roomtype=" + roomtype + "&forceSykonCountry=" + langLong + "&md=get_md_value&r_opt=1";
        if (self.departurePlace !== '' && self.departurePlace !== 'default') {
          href += "&busstop=" + self.departurePlace + "-" + self.arrivalPlace;
        }
        //
      } else {
        href = "//wwwgen.sykon.pl/afiliacjaariadna1B/agx/" + self.agent + "/index.php?szukaj=szukaj_wycieczki&adults=2&top=" + self.touroperator + "&rewrite=on&tourop=agx&agentx=" + self.agent + "&onepage=20&from=" + self.params.start_date + "&to=" + self.params.end_date + "&tourop_hotel=" + self.touroperator + "|" + skrot + "&md=get_md_value";
      }
      return href;
    },
    setParamsFromGet: function () {
      for (let property in this.params) {
        if (this.params.hasOwnProperty(property)) {
          if (this.$route.query.hasOwnProperty(property)) {
            if (this.$route.query[property] != "") {
              this.params[property] = this.$route.query[property];
            }
          }
        }
      }
      if (this.$route.query.hasOwnProperty('scroll') && this.$route.query['scroll'] === 0) {
        this.scroll = this.$route.query['scroll'];
      }
    },
    reloadPageWithNewPath: function () {
      let reload = true;
      let query = {};
      for (let property in this.params) {
        if (property != 'room' && property != 'alimentation') {
          if (this.params.hasOwnProperty(property) && this.params[property] != '' && this.params[property] != 'default') {
            query[property] = this.params[property];
          }
        }
        if (property == 'start_date' || property == 'end_date') {
          if (!moment(this.params[property], 'DD.MM.YYYY', true).isValid()) {
            reload = false;
          }
        }
      }
      if (reload) {
        query['scroll'] = 0;
        router.replace({
          name: 'details',
          params: { skrot2: this.skrot2, room: this.params.room, alimentation: this.params.alimentation },
          query: query
        });
      }
    },
    showDiagram: function () {
      const self = this;

      let content = "";
      content += self.generateDiagramForMonth(self.diagram.first.month, self.diagram.first.year, self.diagram.first.days);
      content += self.generateDiagramForMonth(self.diagram.second.month, self.diagram.second.year, self.diagram.second.days);

      self.diagram.content = content;
    },
    generateDiagramForMonth: function (month, year, days) {
      const theMonths = [
        locales('common.moth.january'),
        locales('common.moth.february'),
        locales('common.moth.march'),
        locales('common.moth.april'),
        locales('common.moth.may'),
        locales('common.moth.june'),
        locales('common.moth.july'),
        locales('common.moth.august'),
        locales('common.moth.september'),
        locales('common.moth.october'),
        locales('common.moth.november'),
        locales('common.moth.december')
      ];

      let today = new Date(year, month, 1);
      let theYear = ((today.getYear() < 1900) ? today.getYear() + 1900 : today.getYear());
      let theMonth = today.getMonth();
      let firstDay = new Date(theYear, theMonth, 1).getDay();
      if (firstDay == 0) {
        firstDay = 7;
      }

      let thisMonth = new Date(theYear, theMonth, 1);
      let nextMonth = new Date(theYear, theMonth + 1, 1);

      let howMany = Math.round((nextMonth.getTime() - thisMonth.getTime()) / (1000 * 60 * 60 * 24)) + firstDay;

      let content = "<table class='diagram-month-tab'>"
      content += "<tr><th colspan=7>" + theMonths[theMonth] + " " + theYear + "</th></tr>"
      content += "<tr><th>Pn.</th><th>Wt.</th><th>Śr.</th><th>Czw.</th><th>Pt.</th><th>Sob.</th><th>Ndz.</th></tr>"
      content += "<tr>"
      for (let i = 1; i < howMany; i++) {
        if (i < firstDay) {
          content += "<td class='dmt-day dmt-day-another-month'></td>"
        } else {
          let freeAllotment = 0;
          let day = new Date(year, month, (i - firstDay + 1));
          let key = ("0" + day.getDate()).slice(-2) + "." + ("0" + (day.getMonth() + 1)).slice(-2) + "." + day.getFullYear();

          if (typeof days[key] !== 'undefined') {
            freeAllotment = days[key];
          }

          let title = '';
          if ($.isNumeric(freeAllotment) && freeAllotment > 0) {
            content += "<td class='dmt-day dmt-day-free'>" + (i - firstDay + 1) + "</td>"
          } else if ($.type(freeAllotment) === "string" && freeAllotment.substring(0, 1) == "F") {
            title = freeAllotment.substring(1, freeAllotment.length);
            content += "<td class='dmt-day dmt-day-free' title='" + title + "'>" + (i - firstDay + 1) + "</td>"
          } else if ($.type(freeAllotment) === "string" && freeAllotment.substring(0, 1) == "A") {
            title = freeAllotment.substring(1, freeAllotment.length);
            content += "<td class='dmt-day dmt-day-arrival' title='" + title + "'>" + (i - firstDay + 1) + "</td>"
          } else if ($.type(freeAllotment) === "string" && freeAllotment.substring(0, 1) == "S") {
            title = freeAllotment.substring(1, freeAllotment.length);
            content += "<td class='dmt-day dmt-day-stop' title='" + title + "'>" + (i - firstDay + 1) + "</td>"
          } else if ($.type(freeAllotment) === "string" && freeAllotment.substring(0, 1) == "L") {
            title = freeAllotment.substring(1, freeAllotment.length);
            content += "<td class='dmt-day dmt-day-locked' title='" + title + "'>" + (i - firstDay + 1) + "</td>"
          } else {
            content += "<td class='dmt-day dmt-day-locked'>" + (i - firstDay + 1) + "</td>"
          }
        }
        if (i % 7 == 0 && i != howMany) {
          content += "</tr><tr>"
        }
      }
      for (let i = 1; i <= 35 - Math.round((nextMonth.getTime() - thisMonth.getTime()) / (1000 * 60 * 60 * 24)) - firstDay + 1; i++) {
        content += "<td class='dmt-day dmt-day-another-month'></td>";
      }
      content += "</table>"
      return content;
    },
    setGetPriceUrl: function (agentx) {
      const self = this;
      if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(agentx)) {
        self.getPriceUrl = "/back/search/GetPrice.php";
      } else {
        self.getPriceUrl = "https://sykons.sykon.pl/ajax2/json_getprice2_kompas.php";
      }
    },
    getPrice: function () {
      const self = this;
      self.showPrice = false;
      self.error = locales('components.search-details.js.count');
      let isError = false;
      self.diagram.content = "";

      let child_age1 = self.params.age_child_1;
      let child_age2 = self.params.age_child_2;
      let child_age3 = self.params.age_child_3;
      let child_age4 = self.params.age_child_4;

      const dateReg = /^\d{2}(.)\d{2}\1\d{4}$/;
      let correct_start_date = (self.params.start_date == "" || !self.params.start_date.match(dateReg)) ? false : true;
      let correct_end_date = (self.params.end_date == "" || !self.params.end_date.match(dateReg)) ? false : true;

      if (self.agent == "lulubeds2www") {
        if (correct_start_date && self.params.end_date == "") {
          self.params.end_date = moment(self.params.start_date, "DD.MM.YYYY").add(1, 'days').format('DD.MM.YYYY');
          return;
        }
      }

      if (self.params.childrens == "0") {
        child_age1 = child_age2 = child_age3 = child_age4 = '';
      }
      else if (self.params.childrens == "1") {
        if (child_age1 == "") {
          self.error = locales('components.search-details.js.select_children_age');
          isError = true;
        } else {
          child_age1 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age1, 'years').format('DD.MM.YYYY');
          child_age2 = child_age3 = child_age4 = '';
        }
      }
      else if (self.params.childrens == "2") {
        if (child_age1 == "" || child_age2 == "") {
          self.error = locales('components.search-details.js.select_children_age');
          isError = true;
        } else {
          child_age1 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age1, 'years').format('DD.MM.YYYY');
          child_age2 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age2, 'years').format('DD.MM.YYYY');
          child_age3 = child_age4 = '';
        }
      }
      else if (self.params.childrens == "3") {
        if (child_age1 == "" || child_age2 == "" || child_age3 == "") {
          self.error = locales('components.search-details.js.select_children_age');
          isError = true;
        } else {
          child_age1 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age1, 'years').format('DD.MM.YYYY');
          child_age2 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age2, 'years').format('DD.MM.YYYY');
          child_age3 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age3, 'years').format('DD.MM.YYYY');
          child_age4 = '';
        }
      }
      else if (self.params.childrens == "4") {
        if (child_age1 == "" || child_age2 == "" || child_age3 == "" || child_age4 == "") {
          self.error = locales('components.search-details.js.select_children_age');
          isError = true;
        } else {
          child_age1 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age1, 'years').format('DD.MM.YYYY');
          child_age2 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age2, 'years').format('DD.MM.YYYY');
          child_age3 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age3, 'years').format('DD.MM.YYYY');
          child_age4 = moment(self.params.start_date, "DD.MM.YYYY").subtract(child_age4, 'years').format('DD.MM.YYYY');
        }
      }

      let data = {
        agentx: self.agent,
        hotel: self.detailsElement.skrot,
        room: (self.params.room !== '-') ? self.params.room.replaceAll("|", "/") : '',
        mw: self.params.mw,
        date_out: self.params.start_date,
        date_in: self.params.end_date,
        adults: self.params.adults,
        child1: child_age1,
        child2: child_age2,
        child3: child_age3,
        child4: child_age4,
        child1age: self.params.age_child_1,
        child2age: self.params.age_child_2,
        child3age: self.params.age_child_3,
        child4age: self.params.age_child_4,
        diagram: true,
        hotel_id: self.detailsElement.id
      };
      if (!correct_start_date) data.date_out = moment().format('DD.MM.YYYY');
      if (!correct_end_date) data.date_in = data.date_out;

      $.get(self.getPriceUrl, data, function (result, textStatus) {
        if (typeof result.diagram !== 'undefined') {
          self.diagram.first = result.diagram[0];
          self.diagram.second = result.diagram[1];
          self.showDiagram();
        }

        if (!correct_start_date || !correct_end_date) {
          self.error = (self.params.start_date == "" || self.params.end_date == "") ? locales('components.search-details.js.select_term') : locales('components.search-details.js.enter_dates');
          isError = true;
        }
        if (isError) return;

        if (typeof result.error !== 'undefined') {
          if (
            self.agent == "lulubeds2www"
            && result.error.indexOf("Hotel error. Cannot find room in Hotel (1) ") > -1
            && (moment(data.date_in, "DD.MM.YYYY").format('YYYY-MM-DD') <= moment(data.date_out, "DD.MM.YYYY").format('YYYY-MM-DD'))
          ) {
            result.error = locales('components.search-details.js.dates_error');
          }

          self.showPrice = false;
          self.error = result.error;
        } else if (typeof result.faultcode !== 'undefined' && typeof result.detail !== 'undefined') {
          self.showPrice = false;
          self.error = result.detail;
        } else if (typeof result.Cost === 'undefined') {
          self.showPrice = false;
          self.error = locales('components.search-details.js.no_price');
        } else {
          self.price = result.Cost[0].UnitPrice;
          self.currency = result.Cost[0].UnitCurrency;
          self.struckPrice = result.ExtraInfo.NormalPricePLN;
          self.discountValue = Math.round(((result.ExtraInfo.NormalPricePLN - result.Cost[0].UnitPrice) * 100) / 100);
          self.discountPercentage = Math.round((100 * (result.Cost[0].UnitPrice - result.ExtraInfo.NormalPricePLN) / result.ExtraInfo.NormalPricePLN));
          self.discountName = result.ExtraInfo.Info1;
          if (typeof result.Flight !== 'undefined' && result.Flight != null) {
            if (typeof result.Flight.Departure.Place !== 'undefined' && result.Flight.Departure.Place != null) {
              self.departurePlace = result.Flight.Departure.Place;
            }
            if (typeof result.Flight.Arrival.Place !== 'undefined' && result.Flight.Arrival.Place != null) {
              self.arrivalPlace = result.Flight.Arrival.Place;
            }
          }
          let discountType = "po";
          if (self.discountName.indexOf("last") != -1) {
            discountType = "lm";
          } else if (self.discountName.indexOf("first") != -1) {
            discountType = "fm";
          }
          self.discountType = discountType;
          self.showPrice = true;
          self.HotelResStatus = result.Hotel.HotelResStatus;
          if (["lulubeds2www", "puntanatura2www", "aturnew2www", "nflight2www"].includes(self.agent) && result.ExtraInfo.Info4 == "") {
            self.struckPrice = self.price;
            self.discountName = "";
            self.discountValue = 0;
            self.discountPercentage = 0;
          }
        }
      }, "json").fail(function () {
        self.error = locales('components.search-details.js.incorrect_room_or_alimentation');
      });
    }
  }
});
